import { css, cva } from "@stubhub/broadway-foundation/css";

export const glassImageHeaderWrapper = css({
  display: "flex",
  flexDirection: "column",
  height: "auto",
  position: "relative",
  justifyContent: "space-between",
  desktop: {
    minHeight: "auto",
  },
});

export const glassImageHeaderWrapperRecipe = cva({
  base: {
    display: "flex",
    flexDirection: "column",
    height: "auto",
    position: "relative",
    justifyContent: "space-between",
    desktop: {
      minHeight: "auto",
    },
  },
  variants: {
    border: {
      none: {},
      residency: {
        borderBlockEndWidth: "thin",
        borderBlockEndStyle: "solid",
        borderBlockEndColor: "border",
      },
    },
  },
  defaultVariants: {
    // eslint-disable-next-line panda/prefer-atomic-properties -- variant name, not a CSS property
    border: "none",
  },
});

export const glassImageContainer = css({
  display: "flex",
  height: "full",
  insetInlineStart: "primitives.0",
  overflowX: "hidden",
  overflowY: "hidden",
  position: "absolute",
  insetBlockStart: "primitives.0",
  width: "full",
  zIndex: "[-1]",
});

export const linearGradientOverlaySurface = css({
  width: "full",
  height: "full",
  position: "absolute",
  backgroundColor: "bg",
});

export const residencyHeroOverlaySurface = css({
  width: "full",
  height: "full",
  position: "absolute",
  zIndex: "[1]",
  backgroundColor: "bg.surface",
});
